import type { Route } from "./+types/about";

export const meta: Route.MetaFunction = () => {
  return [
    { title: `서비스 소개 | ${import.meta.env.VITE_APP_NAME || "AI 내동생"}` },
    {
      name: "description",
      content: "AI 내동생을 개인이 운영하는 서비스의 기본 정보와 미션을 소개합니다.",
    },
  ];
};

export default function About(_: Route.ComponentProps) {
  return (
    <div className="mx-auto w-full max-w-screen-xl space-y-8 px-5 py-10 md:px-10 md:py-16">
      <header className="space-y-2">
        <h1 className="text-2xl font-bold md:text-3xl">서비스 소개</h1>
      </header>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">미션과 원칙</h2>
        <ul className="list-disc space-y-1 pl-5">
          <li>모든 학습자가 스스로 설명하며 성장하도록 돕습니다.</li>
          <li>안전하고 책임있는 AI를 지향하며 개인정보를 소중히 다룹니다.</li>
          <li>정확성·투명성·지속적인 개선을 핵심 가치로 삼습니다.</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">프로젝트 기본 정보</h2>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
          <div>
            <div className="text-muted-foreground text-sm">소유/운영 주체</div>
            <div className="font-medium">개인(유혜영)</div>
          </div>
          <div>
            <div className="text-muted-foreground text-sm">개발/관리</div>
            <div className="font-medium">유혜영 (createyoo0491@gmail.com)</div>
          </div>
          <div className="md:col-span-2">
            <div className="text-muted-foreground text-sm">운영 형태</div>
            <div className="font-medium">
              개인 소유 프로젝트이며 필요시 외부 파트너(예: 비용 후원)와 협력
            </div>
          </div>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">연락처</h2>
        <ul className="space-y-1">
          <li className="flex gap-2">
            <span className="text-muted-foreground">이메일</span>
            <span className="font-medium">createyoo0491@gmail.com</span>
          </li>
        </ul>
      </section>

      <section className="space-y-2">
        <p className="text-muted-foreground text-sm">
          AI 내동생은 개인이 운영하는 학습 보조 소프트웨어로, 투명하고 책임
          있는 방식으로 개선을 이어가겠습니다.
        </p>
      </section>
    </div>
  );
}
